import { useFetch } from "@/helpers/useFetch.js";
const { request, getSearchParams } = useFetch();

export const getOrganizations = (filter, limit, page) => {
  return request("GET", `/auth/organization${getSearchParams(filter, limit, page)}`);
};
export const logout = () => {
  return request("POST", "/auth/logout");
};
export const completeRegistration = (payload) => {
  return request("POST", "/auth/register", payload);
};
export const getProfile = () => {
  return request("GET", `/auth/profile`);
};
export const updateProfile = (payload) => {
  return request("POST", `/auth/profile`, payload);
};
export const switchOrganization = (payload) => {
  return request("POST", `/auth/organization`, payload);
};
